<template>
  <section class="sa-rep-summary" :aria-label="ariaLabel">
    <ReportSummaryMetric
      v-for="metric in metrics"
      :key="metric.label"
      :label="metric.label"
      :value="metric.value"
      :hint="metric.hint || ''"
    />
  </section>
</template>

<script>
import ReportSummaryMetric from './ReportSummaryMetric.vue';

export default {
  name: 'ReportsSummary',
  components: { ReportSummaryMetric },
  props: {
    metrics: { type: Array, default: () => [] },
    ariaLabel: { type: String, default: 'Resumo da visão' },
  },
};
</script>

<style scoped>
.sa-rep-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.75rem;
}

@media (max-width: 1024px) {
  .sa-rep-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .sa-rep-summary {
    grid-template-columns: 1fr;
  }
}
</style>
